export function OutlineSquareMoneyIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9984 3H5.0016C3.89615 3 3 3.89615 3 5.0016V18.9984C3 20.1039 3.89615 21 5.0016 21H18.9984C20.1039 21 21 20.1039 21 18.9984V5.0016C21 3.89615 20.1039 3 18.9984 3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path
        d="M15.1152 9.00059C14.6112 8.63579 13.5408 7.98779 12.1152 8.00219C11.52 8.00699 10.056 8.02139 9.47515 9.00059C9.16315 9.53339 9.09115 10.3734 9.47515 11.0022C10.4832 12.6486 13.7424 11.3574 14.7504 13.0038C15.1344 13.6278 15.0672 14.4726 14.7504 15.0054C14.1888 15.9558 12.8064 15.9894 12.2016 16.0038C10.7424 16.0422 9.63355 15.375 9.11035 15.0054"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path d="M12.1152 6V8.0016" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M12.1152 15.998V17.9996" stroke={stroke} strokeWidth={strokeWidth} />
    </svg>
  );
}
